<nz-spin [nzSpinning]="loading$ | async"
  ><form nz-form class="form" nzLayout="horizontal" [formGroup]="form">
    <div formArrayName="dataItems">
      <div class="drawer-form-wrapper">
        <h3 class="title s-16 mb-16">Enter the number of minutes below</h3>
        <nz-table
          class="number-of-minutes"
          #basicTable
          [nzData]="dataItems.controls"
          nzShowPagination="false"
          [nzScroll]="{ x: '700px', y: 'calc(100vh - 290px)' }">
          <thead>
            <tr>
              <td
                *ngFor="let control of dataItemsControls; let i = index"
                [formGroup]="control"
                [title]="
                  getTitle(
                    control.value.startDataTime,
                    control.value.endDataTime
                  )
                ">
                {{ control.value.startDataTime }} -
                {{ control.value.endDataTime }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rowIndex of [0, 1, 2, 3, 4]">
              <td *ngFor="let control of dataItemsControls; let i = index">
                <div [formGroup]="control">
                  <div formArrayName="unitValue">
                    <input
                      name="enterMinutes"
                      type="text"
                      nz-input
                      mask="000"
                      appAllowOnlyValidNumbers
                      placeholder="Enter minutes"
                      [formControlName]="rowIndex" />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <div class="error-text mt-3 mb-3" *ngIf="!isFormValid">
          Please enter at least 1 frequency value.
        </div>
      </div>
      <div class="display-flex justify-content-between drawer-footer">
        <button nz-button type="button" nzType="default" (click)="onCancel()">
          Cancel
        </button>
        <button
          nz-button
          type="button"
          nzType="primary"
          (click)="submitForm()"
          [disabled]="!isFormValid">
          Save
        </button>
      </div>
    </div>
  </form>
</nz-spin>
